<div class="app-download">

   <app-page-title [title]="title()" [icon]="icon()" eyebrow="Apps" [subtitle]="subtitle()" />

   <!-- ============================== download hero ============================== -->
   <section class="download-hero">
      <p class="description">{{ description() }}</p>

      <div class="downloads">
         <a class="download-btn"
            [class.is-primary]="primary() === 'ios'"
            [class.is-secondary]="primary() === 'android'"
            [href]="iosDownloadUri()" target="_blank" rel="noopener">
            <i class="fa-brands fa-apple" aria-hidden="true"></i>
            <span class="text">
               <span class="small-label">Download for</span>
               <span class="big-label">iPhone &amp; iPad</span>
            </span>
         </a>

         <a class="download-btn"
            [class.is-primary]="primary() === 'android'"
            [class.is-secondary]="primary() === 'ios'"
            [href]="androidDownloadUri()" target="_blank" rel="noopener">
            <i class="fa-brands fa-android" aria-hidden="true"></i>
            <span class="text">
               <span class="small-label">Download for</span>
               <span class="big-label">Android</span>
            </span>
         </a>
      </div>

      <div class="requirements">
         <span><i class="fa-brands fa-apple" aria-hidden="true"></i>{{ iosRequirement() }}</span>
         <span><i class="fa-brands fa-android" aria-hidden="true"></i>{{ androidRequirement() }}</span>
         <span><i class="fa-solid fa-wifi" aria-hidden="true"></i>Needs an internet connection</span>
      </div>
   </section>

   <!-- ============================== install help ============================== -->
   <div class="help-grid">

      <section class="help-card">
         <h2 class="card-title"><i class="fa-solid fa-circle-info" aria-hidden="true"></i>Before you install</h2>
         <ul class="check-list">
            <li>Keep your device on the latest available software version for the best performance and reliability.</li>
            <li>If the install fails, uninstall any previous version of the app first, then try again.</li>
         </ul>
      </section>

      <section class="help-card">
         <h2 class="card-title"><i class="fa-brands fa-android" aria-hidden="true"></i>Android: allow installs from our site</h2>
         <p>
            Android blocks apps that don't come from Google Play until you allow it. Go to
            <strong>Settings &rsaquo; Security</strong> (on some phones <strong>Apps &rsaquo; Special access</strong>)
            and allow installs from unknown sources for your browser.
         </p>
         <a class="help-link" [href]="androidInstructionsUri()" target="_blank" rel="noopener">
            Step-by-step instructions <i class="fa-solid fa-arrow-up-right-from-square" aria-hidden="true"></i>
         </a>
      </section>

      <section class="help-card">
         <h2 class="card-title"><i class="fa-brands fa-apple" aria-hidden="true"></i>iPhone &amp; iPad: trust the app</h2>
         <p>
            Because the app is installed outside the App Store, iOS asks you to trust Southwestern as the developer
            the first time. Go to <strong>Settings &rsaquo; General &rsaquo; VPN &amp; Device Management</strong> and tap Trust.
         </p>
         <a class="help-link" [href]="iosInstructionsUri()" target="_blank" rel="noopener">
            Step-by-step instructions <i class="fa-solid fa-arrow-up-right-from-square" aria-hidden="true"></i>
         </a>
      </section>

   </div>

   <!-- ============================== features ============================== -->
   <section class="help-card features">
      <h2 class="card-title"><i class="fa-solid fa-wand-magic-sparkles" aria-hidden="true"></i>What it does</h2>
      <ul class="check-list">
         <ng-content />
      </ul>
   </section>

   <p class="support">
      Having trouble with the app?
      <a [routerLink]="[supportUri()]">Get support</a>
   </p>

</div>
